import React, { useState, useRef, useEffect } from 'react'

import Button from '../button/button'
import styles from './styles.module.css'

const SelectButton = ({ title, options, onSelect }) => {
    const [open, setOpen] = useState(false)
    const dropdownRef = useRef(null)

    const toggleDropdown = () => {
        setOpen(prev => !prev)
    }

    const handleSelect = (option) => {
        onSelect(option)        
        setOpen(false)
    }

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpen(false)
            }
        }

        if (open) {
            document.addEventListener('mousedown', handleClickOutside)
        } else {
            document.removeEventListener('mousedown', handleClickOutside)
        }

        return () => document.removeEventListener('mousedown', handleClickOutside)
    }, [open])

    return (
        <div className={styles.selectContainer}>
            <Button size="normal" variant="fancy" onClick={toggleDropdown} className={styles.selectButton}>
                {title} 
            </Button>
            {open && (
                <div className={styles.dropdown} ref={dropdownRef}>
                    {options?.map(option => (
                        <div 
                            key={option?.id} 
                            className={styles.dropdownItem} 
                            onClick={() => handleSelect(option)}
                        >
                            {option?.name}
                        </div>
                    ))}
                </div>
            )}
        </div>
    )
}

export default SelectButton
